<template>
  <b-modal id="user-views-modal" size="xl" hide-footer @hidden="$emit('update:users', [])">
    <!-- Search -->
    <b-row>
      <b-col cols="12" md="12">
        <b-form inline class="justify-content-end">
          <label class="mr-sm-2">{{ $t('Search')}}</label>
          <b-form-input></b-form-input>
        </b-form>
      </b-col>
    </b-row>
  
    <b-row class="mt-1">
      <b-col cols="12">
        <b-table
          :items="items"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="$t('gig_page.view_modal.no_matched_record_text')"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <!-- Column: fullName -->
          <template #cell(fullName)="{ value }">
            <b-avatar variant="light-primary" :text="getInitials(value)" />
            <b-link class="ml-1 text-capitalize">
              {{ value }}
            </b-link>
          </template>
  
          <!-- Column: Actions -->
          <template #cell(actions)="{ }">
            <b-dropdown variant="link" no-caret :right="$store.state.hwUiLayout.isRTL">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <b-dropdown-item>
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">{{ $t('Details')}}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-col>
    </b-row>
  
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between align-items-center">
        <span class="text-nowrap">
          {{ $t('footer.showing') }} {{ perPage * (currentPage - 1) + 1 }} {{ $t('footer.to') }}
          {{ perPage * currentPage > users.length ? users.length : perPage * currentPage }} {{ $t('footer.of') }}
          {{ users.length }} {{ $t('footer.entries') }}
        </span>
  
        <b-pagination
          v-model="currentPage"
          hide-goto-end-buttons
          hide-ellipsis
          :per-page="perPage"
          :limit="7"
          :total-rows="users.length"
          class="mb-1"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>
  
  <script>
  import {
    BModal,
    BRow,
    BCol,
    BTable,
    BForm,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BAvatar,
    BLink,
    BPagination,
  } from 'bootstrap-vue'
  import { getInitials } from '@hw-core/utils'
  
  export default {
    components: {
      BModal,
      BRow,
      BCol,
      BForm,
      BFormInput,
      BTable,
      BDropdown,
      BDropdownItem,
      BAvatar,
      BLink,
      BPagination,
    },
    props: {
      users: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        sortBy: 'name',
        sortDesc: false,
        perPage: 10,
        currentPage: 1,
      }
    },
    computed: {
      items() {
        return this.users.slice(
          this.perPage * (this.currentPage - 1),
          this.perPage * this.currentPage
        )
      },
      tableColumns() {
        return [
          {
            key: 'fullName',
            label: this.$t('gig_page.name'),
            sortable: true,
            style: {
              width: '300px',
              maxWidth: '300px',
            },
          },
          {
            key: 'email',
            label: this.$t('gig_page.email'),
            sortable: true,
          },
          {
            key: 'mobile',
            label: this.$t('gig_page.phone'),
            sortable: true,
          },
          {
            key: 'role',
            label: this.$t('gig_page.role'),
            sortable: true,
          },
          {
            key: 'actions',
            label: this.$t('gig_page.actions'),
            style: {
              width: '80px',
              maxWidth: '80px',
            },
          },
        ]
      },
    },
    methods: {
      getInitials,
    },
  }
  </script>
  